import { Injectable } from '@angular/core';

import { HlsUtilService } from './HlsUtil.Service';
import { IVbSource } from './IVbSource';

@Injectable()
export class ClosedCaptionsUtilService {
	constructor(
		private HlsUtilService: HlsUtilService
	) {}

	public isClosedCaptionsSupported(source: IVbSource): boolean {
		if (!source) {
			return false;
		}

		const { src, type }: { src: string; type: string } = source;

		//rtmp, rtmfp, hls
		return this.HlsUtilService.isHLS(src, type);
	}
}
